import { VIPChannel } from '@modules/common/models/enums/VIPChannel'

export enum QuantityType {
  Draft = 'LINE_ITEM_DRAFT_QUANTITY',
  DraftWHL = 'LINE_ITEM_DRAFT_QUANTITY_WHL',
  Size = 'LINE_ITEM_SIZE_QUANTITY',
  Product = 'CLIENT_ORDER_PRODUCT_QUANTITY'
}

export const QUANTITY_TYPE_WARNING_MAPPING = {
  [QuantityType.Draft]: 'doorOrderProductDoorQuantity',
  [QuantityType.Size]: 'doorOrderProductSizeQuantity',
  [QuantityType.Product]: 'clientOrderProductQuantity'
}

export const QUANTITY_TYPE_OPTIONS = [
  {
    id: QuantityType.Product,
    name: 'Product Quantity',
    key: 'productQuantity',
    allowedForChannels: [VIPChannel.Retail, VIPChannel.Wholesale]
  },
  {
    id: QuantityType.Size,
    name: 'Size Quantity',
    key: 'sizeQuantity',
    allowedForChannels: [VIPChannel.Retail, VIPChannel.Wholesale]
  },
  {
    id: QuantityType.Draft,
    name: 'Door Quantity',
    allowedForChannels: [VIPChannel.Retail]
  },
  {
    id: QuantityType.DraftWHL,
    name: 'Draft Quantity',
    allowedForChannels: [VIPChannel.Wholesale]
  }
]

export const QUANTITY_TYPE_SORT_OPTIONS = [
  {
    id: QuantityType.Product,
    name: 'PRODUCT'
  },
  {
    id: QuantityType.Size,
    name: 'SIZED'
  },
  {
    id: QuantityType.Draft,
    name: 'DOOR'
  }
]

export const SHRSortAttributesList: Array<any> = [
  {
    name: 'Quantity',
    value: 'quantity',
    isSelected: false,
    sortOrder: ''
  },
  {
    name: 'Value',
    value: 'value',
    isSelected: false,
    sortOrder: ''
  }
]
